import { useRef } from "react";

// Only the newest request may put rows on the screen. A big unfiltered list can take a few
// seconds; if an officer picks a slicer while it is still coming, its reply must not land on top
// of the filtered list they asked for — which is what made the slicers look broken.
export function useFreshest() {
  const seq = useRef(0);
  return {
    start: () => ++seq.current,
    isFresh: (ticket) => ticket === seq.current,
  };
}
